export function interpretChatStream(messages, lastAnnouncedMarker) {
  const next = Array.isArray(messages) ? messages : [];
  const latest = next.at(-1);
  if (!latest || latest.role !== 'assistant') return { messages: next, assistantArrived: false, marker: lastAnnouncedMarker };
  const marker = latest.id || `${next.length}:assistant:${latest.content ?? ''}`;
  return { messages: next, assistantArrived: marker !== lastAnnouncedMarker, marker };
}

export function abortRecognition(recognitionRef) {
  const recognition = recognitionRef.current;
  recognitionRef.current = null;
  try { recognition?.abort(); } catch {}
}

export function messageNavigationIndex(current, direction, count) {
  if (count <= 0) return -1;
  const start = current < 0 ? (direction === 'previous' ? count : -1) : current;
  return Math.max(0, Math.min(count - 1, start + (direction === 'previous' ? -1 : 1)));
}

export function recognitionErrorMessage(code) {
  if (code === 'not-allowed' || code === 'service-not-allowed') return 'Microphone permission was denied. Allow it in Edge settings or continue by typing. Your typed message is unchanged.';
  if (code === 'no-speech') return 'No new speech was detected. Any captured speech and typed message remain here; you can try again or continue typing.';
  return 'Speech input stopped. Any captured speech and typed message remain here.';
}

export const isPendingDuplicate = (content, pending) => Boolean(pending) && content.trim() === pending;
export const shouldArmReplyWait = (pending, sent) => pending === sent;
export const restoreFailedQuestion = (currentInput, sent) => currentInput || sent;
